"use client";

import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { useEffect, useState } from "react";

export default function ProductTabs() {
  const t = useScopedI18n("产品");

  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: t("产品详情"),
      value: "product-details",
    },
    {
      label: t("设计和开发"),
      value: "design-development",
    },
    {
      label: t("技术文档"),
      value: "technical-documentation",
    },
    {
      label: t("应用方案"),
      value: "application-solutions",
    },
  ];

  return (
    <div className="sticky top-16 z-40 hidden h-[3.75rem] items-center rounded-full bg-[#E5E5E5] shadow-[0px_4px_16px_rgba(0,0,0,0.1)] md:flex">
      {tabs.map((tab, index) => (
        <div
          key={tab.value}
          className={cn(
            "relative z-10 flex h-full flex-1 cursor-pointer items-center justify-center rounded-full text-xl text-[#383838] transition-colors duration-300 hover:text-primary",
            {
              "text-primary": activeTab === index,
            }
          )}
          onClick={() => {
            setActiveTab(index);

            // 滚动到对应位置
            const target = document.getElementById(tab.value);
            if (target) {
              target.scrollIntoView({ behavior: "smooth" });
            }
          }}>
          {tab.label}
        </div>
      ))}

      <div
        style={{
          transform: `translateX(${activeTab * 100}%)`,
        }}
        className={cn(
          "absolute bottom-0 top-0 h-full w-1/4 rounded-full bg-white transition-all duration-500"
        )}></div>
    </div>
  );
}
